<template>
  <div class="">
    <el-dialog
      width="30%"
      title=""
      :visible.sync="isshowCampaignPopup"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="fsize16 mb-0 Add Products text-white">
          Add Variable
        </h3></template
      >
      <div>
        <div class="px-2">
          <div>
            <h6 class="col-4f text-md mb-0">Variable Name *</h6>
            <el-input
              placeholder="Enter..."
              class="mt-2 w-full elselect-border0"
              v-model="variableName"
            ></el-input>
            <p
              class="text-ff3131 fsize9 flex justify-end"
              v-if="submitted && !variableName"
            >
              This Field is Required
            </p>
          </div>
          <div class="mt-6">
            <h6 class="col-4f text-md mb-0">Variable Body *</h6>
            <el-input
              class="quill-height mt-2 elselect-border0"
              v-model="variableBody"
              rows="5"
              cols="49"
              type="textarea"
            ></el-input>
            <p
              class="text-ff3131 fsize9 flex justify-end"
              v-if="submitted && !variableBody"
            >
              This Field is Required
            </p>
          </div>

          <div class="flex gap-4 justify-center mt-8 items-center">
            <vs-button
              @click="handleSubmit()"
              class="border-0 text-white w-full rounded-lg font-normal lg:py-3 fsize14 md:py-3 py-2 px-8 sm-fsize14"
            >
              Submit
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      width="30%"
      title=""
      :visible.sync="isshowCampaignPopupEdit"
      :direction="direction"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="fsize16 mb-0 Add Products text-white">
          Edit Variable
        </h3></template
      >
      <div>
        <div class="px-2">
          <div class="mb-6">
            <h6 class="col-4f fsize14 font-medium mb-0">Variable Name *</h6>
            <el-input
              placeholder="Enter..."
              class="mt-2 w-full elselect-border0"
              v-model="editVariableName"
            ></el-input>
            <p
              class="text-ff3131 fsize9 flex justify-end"
              v-if="submitted && !editVariableName"
            >
              This Field is Required
            </p>
          </div>
          <div>
            <h6 class="col-4f text-md mb-0">Variable Body *</h6>
            <el-input
              class="quill-height mt-2 elselect-border0"
              v-model="editVariableBody"
              rows="5"
              cols="49"
              type="textarea"
            ></el-input>
            <p
              class="text-ff3131 fsize9 flex justify-end"
              v-if="submitted && !editVariableBody"
            >
              This Field is Required
            </p>
          </div>

          <div class="flex gap-4 justify-center mt-8 items-center">
            <vs-button
              @click="handleEdit()"
              class="border-0 text-white w-full rounded-lg font-normal lg:py-3 fsize14 md:py-3 py-2 px-8 sm-fsize14"
            >
              Submit
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="w-full">
      <div class="w-full flex items-center justify-between">
        <div class="w-6/12">
          <div>
            <small class="fsize12 bg-white text-dark font-medium"
              >Search Keywords</small
            >
            <div class="relative">
              <el-input
                placeholder="Search"
                class="w-full mt-2"
                v-model="searchText"
              ></el-input>
              <div class="absolute topright-adj bg-white cursor-pointer">
                <feather-icon icon="SearchIcon" svgClasses="w-6 h-6" />
              </div>
            </div>
          </div>
        </div>
        <div class="w-8/12 flex items-end gap-2 pl-6">
          <div class="w-4/5 flex gap-3">
            <!-- <div class="">
              <small class="fsize12 bg-white text-dark font-medium"
                >Search by Campaign</small
              >
              <el-select v-model="value" placeholder="Select" class="mt-2">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="">
              <small class="fsize12 bg-white text-dark font-medium"
                >Search From
              </small>
              <el-date-picker
                v-model="dateFrom"
                type="date"
                class="mt-2 eldate_full"
                placeholder="Pick a day"
              >
              </el-date-picker>
            </div>
            <div class="">
              <small class="fsize12 bg-white text-dark font-medium"
                >Search to</small
              >
              <el-date-picker
                v-model="dateTo"
                type="date"
                class="mt-2 eldate_full"
                placeholder="Pick a day"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="w-1/4 flex justify-end">
            <vs-button
              @click="isshowCampaignPopup = true"
              class="bg-primary px-5 py-3 border-none rounded-lg text-white flex items-center"
            >
              Create New
            </vs-button>
          </div>
        </div>
      </div>
      <div class="w-full grid grid-cols-3 gap-4 mt-8">
        <div
          v-for="data in variableData"
          :key="data._id"
          class="flex bg-white cursor-pointer elshadow rounded-lg p-4 grid grid-cols-2"
        >
          <div class="flex gap-4">
            <div class="w-full">
              <p class="col-4f fsize14 font-semibold mb-0 lineclamp-3">
                {{ data.variableName }}
              </p>
              <p
                class="col-4f fsize12 mb-0 lineclamp-3"
                v-html="data.variableBody.replaceAll('\n', '<br>')"
              ></p>
              <div class="justify-end items-center gap-2 w-full mt-2">
                <p class="fsize10 mb-0 text-8f8f8f">
                  {{ data.createdAt.split("T")[0] }}
                </p>
              </div>
            </div>
          </div>
          <div class="flex justify-end">
            <feather-icon
              @click="Edit(data)"
              icon="EditIcon"
              svgClasses="w-4 h-4"
              class=""
            />
          </div>
        </div>
      </div>
      <div class="w-full flex justify-end mt-6">
        <el-pagination
          background
          layout="prev,pager,next"
          @current-change="
            (value) => {
              currentPage = value;
              getAll();
            }
          "
          :per-size="perPage"
          :total="totalLength"
        ></el-pagination>
      </div>
      <!-- <div>
        <div class="text-center">
          <img
            src="https://nimbuscluster.blob.core.windows.net/server01/brainedadmin/images/nodatafound.svg"
            alt="image"
            class="w-1/3"
          />
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
export default {
  components: {
    quillEditor,
  },
  watch: {
    searchText: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getAll();
      }, 500),
    },
    dateFrom: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getAll();
      }, 500),
    },
    dateTo: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getAll();
      }, 500),
    },
  },
  data() {
    return {
      isshowCampaignPopup: false,
      editorOption: {},
      options: [
        {
          value: "Option1",
          label: "Option1",
        },
        {
          value: "Option2",
          label: "Option2",
        },
      ],
      value: "",
      mailMessage: "",
      dateFrom: "",
      dateTo: "",
      searchText: "",
      variableBody: "",
      variableName: "",
      editVariableBody: "",
      editVariableName: "",
      variableData: [],
      totalLength: "",
      perPage: 12,
      currentPage: 1,
      submitted: false,
      _id: "",
      isshowCampaignPopupEdit: false,
    };
  },
  methods: {
    async handleEdit() {
      try {
        this.submitted = true;
        if (this.editVariableName.trim() && this.editVariableBody.trim()) {
          let payload = {
            variableName: this.editVariableName,
            variableBody: this.editVariableBody,
            _id: this._id,
          };

          let data = await this.$store.dispatch("variable/update", payload);

          if (data.code == 200) {
            this.isshowCampaignPopupEdit = false;
            this.submitted = false;
            const res = await this.$swal({
              icon: "success",
              title: "Variable updated Successfully",
              showConfirmButton: true,
            });
            this.editVariableName = "";
            this.editVariableBody = "";
            this._id = "";
            this.getAll();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    Edit(data) {
      this._id = data._id;
      this.editVariableName = data.variableName;
      this.editVariableBody = data.variableBody;
      this.isshowCampaignPopupEdit = true;
    },
    async handleSubmit() {
      try {
        this.submitted = true;
        if (this.variableName.trim() && this.variableBody.trim()) {
          let payload = {
            variableName: this.variableName,
            variableBody: this.variableBody,
          };

          let data = await this.$store.dispatch("variable/add", payload);

          if (data.code == 200) {
            this.isshowCampaignPopup = false;
            this.submitted = false;
            const res = await this.$swal({
              icon: "success",
              title: "Variable Created Successfully",
              showConfirmButton: true,
            });
            this.variableName = "";
            this.variableBody = "";
            this.getAll();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getAll() {
      try {
        if (this.currentPage > 1) {
          let payload = {
            offset: (this.currentPage - 1) * 12,
          };
          if (this.searchText) {
            Object.assign(payload, { search: this.searchText });
          }
          if (this.dateFrom) {
            let date = new Date(this.dateFrom);
            let date1 = date.toISOString();
            date = new Date(date1);
            date.setDate(date.getDate() + 1);
            Object.assign(payload, { dateFrom: date.toISOString() });
          }
          if (this.dateTo) {
            let date = new Date(this.dateTo);
            let date1 = date.toISOString();
            date = new Date(date1);
            date.setDate(date.getDate() + 1);
            Object.assign(payload, { dateTo: date.toISOString() });
          }
          let data = await this.$store.dispatch("variable/getAll", payload);

          if (data.code == 200) {
            this.variableData = data.data.record;
            this.totalLength = data.data.totalLength;
          }
        } else {
          let payload = {};
          if (this.searchText) {
            Object.assign(payload, { search: this.searchText });
          }
          if (this.dateFrom) {
            let date = new Date(this.dateFrom);
            let date1 = date.toISOString();
            date = new Date(date1);
            date.setDate(date.getDate() + 1);
            console.log(date);
            Object.assign(payload, { dateFrom: date.toISOString() });
          }
          if (this.dateTo) {
            let date = new Date(this.dateTo);
            let date1 = date.toISOString();
            date = new Date(date1);
            date.setDate(date.getDate() + 1);
            console.log(date);
            Object.assign(payload, { dateTo: date.toISOString() });
          }
          let data = await this.$store.dispatch("variable/getAll", payload);

          if (data.code == 200) {
            this.variableData = data.data.record;
            this.totalLength = data.data.totalLength;
          }
        }
      } catch (err) {}
    },
  },
  mounted() {
    this.getAll();
  },
};
</script>
<style>
.adjust {
  position: absolute;
  margin-left: 328px;
  margin-bottom: 90px;
}
</style>
